export type CellOrigins = {
  platform_api: string;
  connect_api: string;
  core_api: string;
  agentos: string;
  voice: string;
};

export type DirectoryCell = {
  object: string;
  operator_id: string;
  code: string;
  name: string;
  headquarters_country: string;
  workos_organization_id: string;
  status: string;
  origins: CellOrigins;
  hub_origin: string;
  portal_origin: string;
};

const KEY = 'forest.global.cell-bind';

export type CellBind = { cell: DirectoryCell; access_code: string };

export function readCellBind(): CellBind | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CellBind;
  } catch {
    return null;
  }
}

export function writeCellBind(bind: CellBind): void {
  sessionStorage.setItem(KEY, JSON.stringify(bind));
}

export function clearCellBind(): void {
  sessionStorage.removeItem(KEY);
}

export function requireBoundConnectOrigin(): string {
  const origin = readCellBind()?.cell.origins.connect_api;
  if (!origin) throw new Error('No cell bound');
  return origin;
}
